module.exports = __webpack_public_path__ + "img/upcoming.fe390d69.jpg";